'use es6';

import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { omit } from 'underscore';
import Immutable from 'immutable';
import { trackGoodInfo } from '../actions/GoodsActions';
import { getUrlWithNonInitialFiltersAndPageShown, getQueryParams } from '../utils/utils';
import UIRouterLink from 'ui-addon-react-router/UIRouterLink';

var FilterRouterLink = /*#__PURE__*/function (_PureComponent) {
  _inherits(FilterRouterLink, _PureComponent);

  function FilterRouterLink() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, FilterRouterLink);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FilterRouterLink)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.trackGoodInfoClick = function () {
      var _this$props = _this.props,
          filters = _this$props.filters,
          trackGoodInfoClick = _this$props.trackGoodInfoClick;
      var trackingData = getQueryParams(filters);
      trackGoodInfoClick(trackingData);
    };

    return _this;
  }

  _createClass(FilterRouterLink, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          filters = _this$props2.filters,
          rest = _objectWithoutProperties(_this$props2, ["filters"]);

      return React.createElement(UIRouterLink, Object.assign({}, omit(rest, 'trackGoodInfoClick'), {
        onClick: this.trackGoodInfoClick,
        to: getUrlWithNonInitialFiltersAndPageShown(filters)
      }));
    }
  }]);

  return FilterRouterLink;
}(PureComponent);

FilterRouterLink.propTypes = {
  filters: PropTypes.instanceOf(Immutable.Map).isRequired,
  trackGoodInfoClick: PropTypes.func.isRequired
};
var mapDispatchToProps = {
  trackGoodInfoClick: trackGoodInfo
};
export default connect(null, mapDispatchToProps)(FilterRouterLink);